// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FullCalendar */

::ng-deep a:hover {
  text-decoration: none;
}

::ng-deep a.fc-event {
  color: #fff;
}

::ng-deep a.fc-event:hover {
  color: #23527c;
}

::ng-deep .fc-event.event-pending:hover, .fc-event.event-corrected:hover, .fc-event.event-deleted:hover {
  color: #fff;
}

::ng-deep .fc .fc-scrollgrid {
  border-right-width : 1px;
  border-collapse: collapse;
}

::ng-deep .fc .fc-scrollgrid-section > * {
  border-top-width: 1px;
}

::ng-deep thead {
  background-color: #E5E5E5;
}

::ng-deep .fc .fc-button-group > .fc-button {
  flex: 1 1 auto;
  position: relative;
  margin-left: 5px! important;
}

::ng-deep .fc .fc-daygrid-day.fc-day-today {
	background: rgb(228, 241, 255);
}

::ng-deep button.fc-today-button.fc-button.fc-button-primary {
  background-color: #0F52BA;
  border-color: #0F52BA;
}

.fc .fc-scrollgrid table {
  border-left-style: hidden;
  border-right-style: hidden;
}

.fc-event, a.fc-basic-view {
  border: none;
  padding: 0 5px;
  border-radius: 3px;
  background-color: #0077B5;
  align-items: center;
  display: flex;
  color: #fff;
}

div#fc-container {
	transform: translateX(0);
	opacity: 1;
	transition: all .3s ease-in;
}
div#fc-container.moveLeftToRight {
	transform: translateX(-50px);
	opacity: 0;
	transition: transform 0s;
}
div#fc-container.moveRightToLeft {
	transform: translateX(50px);
	opacity: 0;
	transition: transform 0s;
}

.fc {
	margin-bottom: 50px;
}

::ng-deep .fc .fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5em;
  margin-top: 1.5em;
}

.fc-custom-toolbar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #0077B5;
}

::ng-deep .fc-toolbar-title, #dahsboard {
  color: #1a252f;
}

.fc-custom-toolbar-title {
	display: flex;
	flex-direction: row !important;
	align-items: center;
	font-size: 1.1em;
	color: #0077B5;
  margin-left: 5px;
  margin-bottom: 20px;
}

.fc-custom-toolbar .btn {
	padding-left: 3px;
	padding-right: 3px;
}
.fc-custom-toolbar .btn-primary:focus,
.fc-custom-toolbar .btn-primary.focus,
.fc-custom-toolbar .btn-primary:hover,
.fc-custom-toolbar .btn-primary:active {
	background: none !important;
}

.fc .fc-head td, .fc th {
	color: rgba(0,0,0,.3);
	border: none;
}
::ng-deep .fc th {
	text-align: center;
	text-transform: capitalize;
	color: #0077B5;
	font-weight: 400;
	padding-bottom: 5px;
}
::ng-deep .fc .fc-ltr .fc-basic-view .fc-day-top .fc-day-number {
	text-align: left;
	padding-left: 5px;
	font-size: 26px;
	color: rgba(0,0,0,.3);
	float: none;
}
.fc-ltr .fc-basic-view .fc-day-top.fc-today .fc-day-number {
	color: #0077B5;
}
.fc .fc-content, .fc .fc-divider, .fc .fc-popover, .fc .fc-row, .fc tbody, .fc td, .fc th, .fc-basic-view thead  {
	border-color: #dfdfdf;
}

.fc-event {
	border: none;
	padding: 0 5px;
	border-radius: 3px;
	background-color: #0077B5;
	align-items: center;
 	display: flex;
}

.fc-event.event-pending, .fc-event.event-corrected, .fc-event.event-deleted {
	background: repeating-linear-gradient(45deg, #34495e, #34495e 10px, #2c3e50 10px, #2c3e50 20px) !important;
	padding-left: 30px;
}

.fc-event.event-pending:before,
.fc-event.event-corrected:before,
.fc-event.event-deleted:before {
	font-family: "Material Icons";
	color: #fff !important;
	margin-left: -25px;
	margin-right: 5px;
	font-size: 12px;
}
.fc-event.event-pending.fc-not-start:before,
.fc-event.event-corrected.fc-not-start:before,
.fc-event.event-deleted.fc-not-start:before {
	margin-left: 5px;
}

.fc-event.event-pending:before {
	content: "\\E889" !important;
}
.fc-event.event-corrected:before {
	content: "\\E3C9" !important;
}
.fc-event.event-deleted:before {
	content: "\\E872" !important;
}
.fc-event.event-am {
	padding-right: 30px;
}
.fc-event.event-am:after {
	content: "AM";
	margin-left: auto;
	margin-right: -25px;
}
.fc-event.event-pm {
	padding-left: 30px;
}
.fc-event.event-pm:before {
	content: "PM";
	margin-left: -25px;
	margin-right: 5px;
}
.fc-event.event-aw {
  padding-left: 30px;
}
.fc-event.event-aw:before {
  content: "AW";
  margin-left: -25px;
  margin-right: 5px;
}
.fc-event.event-am:after, .fc-event.event-pm:before, .fc-event.event-aw:before {
	color: rgba(255,255,255,.5);
}
.fc-event.fc-not-start.event-aw:before, .fc-event.fc-not-start.event-pm:before, .fc-event.fc-not-end.event-am:after {
   display: none
}
.fc-event:hover {
	opacity: .7;
  color: #0077B5;
}
.fc-content {
	text-overflow: ellipsis;
}
.fc-content .fc-time {
	display: none;
}
.fc-resizer {
	display: none;
}

.fc-row.fc-week {
	max-height: 94px;
}

.fc-day-grid-container {
	height: auto !important;
	overflow: hidden !important;
}

.fc-day-grid-event {
	margin-top: 2px !important;
}

.ui-icon {
	text-indent: 0;
}

.fc button {
	padding: 6px 12px;
}
.fc-prev-button, .fc-next-button, .fc-dayGridMonth-button, .fc-multiMonthYear-button, .fc-multiMonthFourMonth-button {
	color: #3c77ab;
	border: 1px solid #ddd;
	background-color: #fff;
}
.fc-prev-button:hover, .fc-next-button:hover {
	background-color: #eee;
	color: #23527c;
}

::ng-deep .fc-dayGridMonth-button {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

::ng-deep button.fc-multiMonthYear-button {
  border-radius: 4px !important;

}

::ng-deep .fc-multimonth-title {
  color: #1a252f;
}

::ng-deep .fc-multiMonthFourMonth-button {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.fc-prev-button {
	border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.fc-next-button {
	border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.fc-head .fc-row {
   border: none;
   display: inherit;
}
.fc-body {
	cursor: pointer;
}

::ng-deep .select-box-container {
  margin-left: 15px;
  margin-right: 15px;
}

/* Tabs */
::ng-deep .p-tabview {
	padding: 0;
}

::ng-deep .p-tabview-nav {
  padding: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.13);
}

::ng-deep .p-tabview .p-tabview-nav-content li a {
  float: left;
  padding: 0.5em 1em;
  text-decoration: none;
}

::ng-deep .p-tabview .p-tabview-panel {
	padding: 20px 0 0 !important;
}

::ng-deep .p-tabview.p-tabview-top > .p-tabview-nav-content li {
	margin: 0;
	padding: 3px 0;
	font-size: 14px;
}
::ng-deep .p-tabview .p-tabview-nav li a {
	color: rgba(0, 0, 0, 0.54);
	text-transform: uppercase;
	font-weight: 500;
	line-height: 25px;
	font-size: 13px;
  padding: 10px;
}
::ng-deep .p-tabview .p-tabview-nav li.p-tabview-selected a,
.p-tabview .p-tabview-nav li.p-state-disabled a,
.p-tabview .p-tabview-nav li.p-state-processing a {
	color: #0077B5;
	cursor: default;
}

::ng-deep .p-tabview .p-tabview-nav li.p-state-disabled a {
	color: rgba(0, 0, 0, 0.54);
}

::ng-deep li.p-highlight {
	border-bottom: 3px solid #0077B5;
}

::ng-deep li.p-highlight a span.p-tabview-title {
	color: #0077B5;
	cursor: default;
}

::ng-deep .p-tabview.p-tabview-top > .p-tabview-nav li {
	top: 0;
}

/* Search */
::ng-deep .p-tabview.p-tabview-top .form-group.search {
	margin-bottom: 24px;
}

::ng-deep .p-tabview.p-tabview-top .form-group .search-before {
	position: absolute;
	color: #9f9f9f;
	top: 7px;
	left: 10px;
}

::ng-deep .p-tabview.p-tabview-top .form-group input#search {
	background: #fff;
	border-radius: 2px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
	padding: 6px 40px 6px 45px;
	transition: box-shadow .2s ease-out;
}

::ng-deep .p-tabview.p-tabview-top .form-group input#search:hover,
.p-tabview.p-tabview-top .form-group input#search:focus {
	box-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22);
}

::ng-deep .p-tabview.p-tabview-top .form-group input#search + button#resetSearch {
	position: absolute;
  top: 4px;
  right: 2px;
  margin: 0;
  font-size: 21px;
  padding: 0px;
	color: #9f9f9f;
}
::ng-deep .p-tabview.p-tabview-top .form-group input#search + button#resetSearch:hover {
	text-decoration: none;
}
::ng-deep .p-tabview.p-tabview-top .form-group input#search + button#resetSearch i {
	top: 0;
}

/** Buttons Success - Warn **/
.btn.btn-success-custom {
  background-color: #27ae60;
}

.btn:not(.btn-raised):not(.btn-link):hover.btn-success-custom {
	background-color: #2CC36B;
	color: rgba(255,255,255,.7)
}

.btn.btn-danger-custom {
  background-color: #e74c3c;
  color: rgba(255,255,255, 0.84);
}

.btn:not(.btn-raised):not(.btn-link):hover.btn-danger-custom {
	background-color: #EA6153;
	color: rgba(255,255,255,.7)
}

@media (max-width: 768px) {
  ::ng-deep .p-tabview .p-tabview-panel {
    padding: 0 !important;
  }

  .list-group:not(.list-group-modal) {
    margin: -10px -15px -20px;
    position: relative !important;
    top: 30px;
  }

  ::ng-deep .fc .fc-toolbar.fc-header-toolbar {
    margin-top : 70px !important;
    zoom:100% !important;
  }

  ::ng-deep .fc  .fc-view-harness {
    margin-top: 60px;
  }

  ::ng-deep .p-tabview-panels {
    width: 100%;
  }

  .fc-col-header > thead, .fc-col-header > tbody > tr > td {
    width: 100%;
  }
}

@-moz-document url-prefix() {
  .fc th {
    padding-bottom: 0 !important;
    padding-left: 0 !important;
    font-size: 14px !important;
    font-weight: 900 !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/app/Components/TimeManagement/timemanagement.component.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;CACC,wBAAwB;CACxB,UAAU;CACV,2BAA2B;AAC5B;AACA;CACC,4BAA4B;CAC5B,UAAU;CACV,wBAAwB;AACzB;AACA;CACC,2BAA2B;CAC3B,UAAU;CACV,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,cAAc;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;;;;CAIC,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;CACf,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;EAClB,aAAa;AACf;;AAEA;CACC,0GAA0G;CAC1G,kBAAkB;AACnB;;AAEA;;;CAGC,6BAA6B;CAC7B,sBAAsB;CACtB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;AAChB;AACA;;;CAGC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,iBAAiB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;AACA;CACC,2BAA2B;AAC5B;AACA;GACG;AACH;AACA;CACC,WAAW;EACV,cAAc;AAChB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,sBAAsB;CACtB,sBAAsB;AACvB;AACA;CACC,sBAAsB;CACtB,cAAc;AACf;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;CACC,2BAA2B;EAC1B,8BAA8B;AAChC;AACA;CACC,4BAA4B;EAC3B,+BAA+B;AACjC;AACA;GACG,YAAY;GACZ,gBAAgB;AACnB;AACA;CACC,eAAe;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,SAAS;AACT;CACC,UAAU;AACX;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,SAAS;CACT,cAAc;CACd,eAAe;AAChB;AACA;CACC,0BAA0B;CAC1B,yBAAyB;CACzB,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;EACd,aAAa;AACf;AACA;;;CAGC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,MAAM;AACP;;AAEA,WAAW;AACX;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kEAAkE;CAClE,0BAA0B;CAC1B,mCAAmC;AACpC;;AAEA;;CAEC,mEAAmE;AACpE;;AAEA;CACC,kBAAkB;EACjB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,eAAe;EACf,YAAY;CACb,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;CACC,MAAM;AACP;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;CACC,yBAAyB;CACzB;AACD;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":["/* FullCalendar */\n\n::ng-deep a:hover {\n  text-decoration: none;\n}\n\n::ng-deep a.fc-event {\n  color: #fff;\n}\n\n::ng-deep a.fc-event:hover {\n  color: #23527c;\n}\n\n::ng-deep .fc-event.event-pending:hover, .fc-event.event-corrected:hover, .fc-event.event-deleted:hover {\n  color: #fff;\n}\n\n::ng-deep .fc .fc-scrollgrid {\n  border-right-width : 1px;\n  border-collapse: collapse;\n}\n\n::ng-deep .fc .fc-scrollgrid-section > * {\n  border-top-width: 1px;\n}\n\n::ng-deep thead {\n  background-color: #E5E5E5;\n}\n\n::ng-deep .fc .fc-button-group > .fc-button {\n  flex: 1 1 auto;\n  position: relative;\n  margin-left: 5px! important;\n}\n\n::ng-deep .fc .fc-daygrid-day.fc-day-today {\n\tbackground: rgb(228, 241, 255);\n}\n\n::ng-deep button.fc-today-button.fc-button.fc-button-primary {\n  background-color: #0F52BA;\n  border-color: #0F52BA;\n}\n\n.fc .fc-scrollgrid table {\n  border-left-style: hidden;\n  border-right-style: hidden;\n}\n\n.fc-event, a.fc-basic-view {\n  border: none;\n  padding: 0 5px;\n  border-radius: 3px;\n  background-color: #0077B5;\n  align-items: center;\n  display: flex;\n  color: #fff;\n}\n\ndiv#fc-container {\n\ttransform: translateX(0);\n\topacity: 1;\n\ttransition: all .3s ease-in;\n}\ndiv#fc-container.moveLeftToRight {\n\ttransform: translateX(-50px);\n\topacity: 0;\n\ttransition: transform 0s;\n}\ndiv#fc-container.moveRightToLeft {\n\ttransform: translateX(50px);\n\topacity: 0;\n\ttransition: transform 0s;\n}\n\n.fc {\n\tmargin-bottom: 50px;\n}\n\n::ng-deep .fc .fc-toolbar.fc-header-toolbar {\n  margin-bottom: 1.5em;\n  margin-top: 1.5em;\n}\n\n.fc-custom-toolbar {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: #0077B5;\n}\n\n::ng-deep .fc-toolbar-title, #dahsboard {\n  color: #1a252f;\n}\n\n.fc-custom-toolbar-title {\n\tdisplay: flex;\n\tflex-direction: row !important;\n\talign-items: center;\n\tfont-size: 1.1em;\n\tcolor: #0077B5;\n  margin-left: 5px;\n  margin-bottom: 20px;\n}\n\n.fc-custom-toolbar .btn {\n\tpadding-left: 3px;\n\tpadding-right: 3px;\n}\n.fc-custom-toolbar .btn-primary:focus,\n.fc-custom-toolbar .btn-primary.focus,\n.fc-custom-toolbar .btn-primary:hover,\n.fc-custom-toolbar .btn-primary:active {\n\tbackground: none !important;\n}\n\n.fc .fc-head td, .fc th {\n\tcolor: rgba(0,0,0,.3);\n\tborder: none;\n}\n::ng-deep .fc th {\n\ttext-align: center;\n\ttext-transform: capitalize;\n\tcolor: #0077B5;\n\tfont-weight: 400;\n\tpadding-bottom: 5px;\n}\n::ng-deep .fc .fc-ltr .fc-basic-view .fc-day-top .fc-day-number {\n\ttext-align: left;\n\tpadding-left: 5px;\n\tfont-size: 26px;\n\tcolor: rgba(0,0,0,.3);\n\tfloat: none;\n}\n.fc-ltr .fc-basic-view .fc-day-top.fc-today .fc-day-number {\n\tcolor: #0077B5;\n}\n.fc .fc-content, .fc .fc-divider, .fc .fc-popover, .fc .fc-row, .fc tbody, .fc td, .fc th, .fc-basic-view thead  {\n\tborder-color: #dfdfdf;\n}\n\n.fc-event {\n\tborder: none;\n\tpadding: 0 5px;\n\tborder-radius: 3px;\n\tbackground-color: #0077B5;\n\talign-items: center;\n \tdisplay: flex;\n}\n\n.fc-event.event-pending, .fc-event.event-corrected, .fc-event.event-deleted {\n\tbackground: repeating-linear-gradient(45deg, #34495e, #34495e 10px, #2c3e50 10px, #2c3e50 20px) !important;\n\tpadding-left: 30px;\n}\n\n.fc-event.event-pending:before,\n.fc-event.event-corrected:before,\n.fc-event.event-deleted:before {\n\tfont-family: \"Material Icons\";\n\tcolor: #fff !important;\n\tmargin-left: -25px;\n\tmargin-right: 5px;\n\tfont-size: 12px;\n}\n.fc-event.event-pending.fc-not-start:before,\n.fc-event.event-corrected.fc-not-start:before,\n.fc-event.event-deleted.fc-not-start:before {\n\tmargin-left: 5px;\n}\n\n.fc-event.event-pending:before {\n\tcontent: \"\\E889\" !important;\n}\n.fc-event.event-corrected:before {\n\tcontent: \"\\E3C9\" !important;\n}\n.fc-event.event-deleted:before {\n\tcontent: \"\\E872\" !important;\n}\n.fc-event.event-am {\n\tpadding-right: 30px;\n}\n.fc-event.event-am:after {\n\tcontent: \"AM\";\n\tmargin-left: auto;\n\tmargin-right: -25px;\n}\n.fc-event.event-pm {\n\tpadding-left: 30px;\n}\n.fc-event.event-pm:before {\n\tcontent: \"PM\";\n\tmargin-left: -25px;\n\tmargin-right: 5px;\n}\n.fc-event.event-aw {\n  padding-left: 30px;\n}\n.fc-event.event-aw:before {\n  content: \"AW\";\n  margin-left: -25px;\n  margin-right: 5px;\n}\n.fc-event.event-am:after, .fc-event.event-pm:before, .fc-event.event-aw:before {\n\tcolor: rgba(255,255,255,.5);\n}\n.fc-event.fc-not-start.event-aw:before, .fc-event.fc-not-start.event-pm:before, .fc-event.fc-not-end.event-am:after {\n   display: none\n}\n.fc-event:hover {\n\topacity: .7;\n  color: #0077B5;\n}\n.fc-content {\n\ttext-overflow: ellipsis;\n}\n.fc-content .fc-time {\n\tdisplay: none;\n}\n.fc-resizer {\n\tdisplay: none;\n}\n\n.fc-row.fc-week {\n\tmax-height: 94px;\n}\n\n.fc-day-grid-container {\n\theight: auto !important;\n\toverflow: hidden !important;\n}\n\n.fc-day-grid-event {\n\tmargin-top: 2px !important;\n}\n\n.ui-icon {\n\ttext-indent: 0;\n}\n\n.fc button {\n\tpadding: 6px 12px;\n}\n.fc-prev-button, .fc-next-button, .fc-dayGridMonth-button, .fc-multiMonthYear-button, .fc-multiMonthFourMonth-button {\n\tcolor: #3c77ab;\n\tborder: 1px solid #ddd;\n\tbackground-color: #fff;\n}\n.fc-prev-button:hover, .fc-next-button:hover {\n\tbackground-color: #eee;\n\tcolor: #23527c;\n}\n\n::ng-deep .fc-dayGridMonth-button {\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n::ng-deep button.fc-multiMonthYear-button {\n  border-radius: 4px !important;\n\n}\n\n::ng-deep .fc-multimonth-title {\n  color: #1a252f;\n}\n\n::ng-deep .fc-multiMonthFourMonth-button {\n  border-top-left-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}\n\n.fc-prev-button {\n\tborder-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.fc-next-button {\n\tborder-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.fc-head .fc-row {\n   border: none;\n   display: inherit;\n}\n.fc-body {\n\tcursor: pointer;\n}\n\n::ng-deep .select-box-container {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n/* Tabs */\n::ng-deep .p-tabview {\n\tpadding: 0;\n}\n\n::ng-deep .p-tabview-nav {\n  padding: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.13);\n}\n\n::ng-deep .p-tabview .p-tabview-nav-content li a {\n  float: left;\n  padding: 0.5em 1em;\n  text-decoration: none;\n}\n\n::ng-deep .p-tabview .p-tabview-panel {\n\tpadding: 20px 0 0 !important;\n}\n\n::ng-deep .p-tabview.p-tabview-top > .p-tabview-nav-content li {\n\tmargin: 0;\n\tpadding: 3px 0;\n\tfont-size: 14px;\n}\n::ng-deep .p-tabview .p-tabview-nav li a {\n\tcolor: rgba(0, 0, 0, 0.54);\n\ttext-transform: uppercase;\n\tfont-weight: 500;\n\tline-height: 25px;\n\tfont-size: 13px;\n  padding: 10px;\n}\n::ng-deep .p-tabview .p-tabview-nav li.p-tabview-selected a,\n.p-tabview .p-tabview-nav li.p-state-disabled a,\n.p-tabview .p-tabview-nav li.p-state-processing a {\n\tcolor: #0077B5;\n\tcursor: default;\n}\n\n::ng-deep .p-tabview .p-tabview-nav li.p-state-disabled a {\n\tcolor: rgba(0, 0, 0, 0.54);\n}\n\n::ng-deep li.p-highlight {\n\tborder-bottom: 3px solid #0077B5;\n}\n\n::ng-deep li.p-highlight a span.p-tabview-title {\n\tcolor: #0077B5;\n\tcursor: default;\n}\n\n::ng-deep .p-tabview.p-tabview-top > .p-tabview-nav li {\n\ttop: 0;\n}\n\n/* Search */\n::ng-deep .p-tabview.p-tabview-top .form-group.search {\n\tmargin-bottom: 24px;\n}\n\n::ng-deep .p-tabview.p-tabview-top .form-group .search-before {\n\tposition: absolute;\n\tcolor: #9f9f9f;\n\ttop: 7px;\n\tleft: 10px;\n}\n\n::ng-deep .p-tabview.p-tabview-top .form-group input#search {\n\tbackground: #fff;\n\tborder-radius: 2px;\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n\tpadding: 6px 40px 6px 45px;\n\ttransition: box-shadow .2s ease-out;\n}\n\n::ng-deep .p-tabview.p-tabview-top .form-group input#search:hover,\n.p-tabview.p-tabview-top .form-group input#search:focus {\n\tbox-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22);\n}\n\n::ng-deep .p-tabview.p-tabview-top .form-group input#search + button#resetSearch {\n\tposition: absolute;\n  top: 4px;\n  right: 2px;\n  margin: 0;\n  font-size: 21px;\n  padding: 0px;\n\tcolor: #9f9f9f;\n}\n::ng-deep .p-tabview.p-tabview-top .form-group input#search + button#resetSearch:hover {\n\ttext-decoration: none;\n}\n::ng-deep .p-tabview.p-tabview-top .form-group input#search + button#resetSearch i {\n\ttop: 0;\n}\n\n/** Buttons Success - Warn **/\n.btn.btn-success-custom {\n  background-color: #27ae60;\n}\n\n.btn:not(.btn-raised):not(.btn-link):hover.btn-success-custom {\n\tbackground-color: #2CC36B;\n\tcolor: rgba(255,255,255,.7)\n}\n\n.btn.btn-danger-custom {\n  background-color: #e74c3c;\n  color: rgba(255,255,255, 0.84);\n}\n\n.btn:not(.btn-raised):not(.btn-link):hover.btn-danger-custom {\n\tbackground-color: #EA6153;\n\tcolor: rgba(255,255,255,.7)\n}\n\n@media (max-width: 768px) {\n  ::ng-deep .p-tabview .p-tabview-panel {\n    padding: 0 !important;\n  }\n\n  .list-group:not(.list-group-modal) {\n    margin: -10px -15px -20px;\n    position: relative !important;\n    top: 30px;\n  }\n\n  ::ng-deep .fc .fc-toolbar.fc-header-toolbar {\n    margin-top : 70px !important;\n    zoom:100% !important;\n  }\n\n  ::ng-deep .fc  .fc-view-harness {\n    margin-top: 60px;\n  }\n\n  ::ng-deep .p-tabview-panels {\n    width: 100%;\n  }\n\n  .fc-col-header > thead, .fc-col-header > tbody > tr > td {\n    width: 100%;\n  }\n}\n\n@-moz-document url-prefix() {\n  .fc th {\n    padding-bottom: 0 !important;\n    padding-left: 0 !important;\n    font-size: 14px !important;\n    font-weight: 900 !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
